import React, { useState } from 'react';
import CareerForm from '../components/CareerForm';

function Careers() {
  const [showForm, setShowForm] = useState(false);
  const [selectedPosition, setSelectedPosition] = useState('');

  const positions = [
    {
      title: 'Hair Replacement Specialist',
      description:
        'Experienced in client consultations, custom hair systems, fitting, cut-in, blending, and maintenance support.',
      requirements: [
        'Experience with hair replacement systems',
        'Strong consultation skills',
        'Attention to natural-looking detail',
      ],
    },
    {
      title: 'Hair System Maintenance Technician',
      description:
        'Focused on system cleaning, reattachment preparation, client comfort, and appointment support.',
      requirements: [
        'Experience with hair systems preferred',
        'Careful sanitation habits',
        'Reliable client service',
      ],
    },
    {
      title: 'Cut-In and Blending Specialist',
      description: 'Skilled in shaping and blending hair systems for a natural, wearable finish.',
      requirements: [
        'Strong cutting and blending experience',
        'Comfort working with custom hair systems',
        'Detail-oriented finish work',
      ],
    },
    {
      title: 'Client Care Coordinator',
      description:
        'Supports consultations, scheduling, follow-ups, and client education for hair replacement services.',
      requirements: [
        'Excellent communication',
        'Organized scheduling habits',
        'Professional client follow-up',
      ],
    },
    {
      title: 'Hair System Care Educator',
      description:
        'Helps clients understand home care routines, product use, wear schedules, and maintenance expectations.',
      requirements: [
        'Hair replacement knowledge',
        'Patient teaching style',
        'Clear product and care guidance',
      ],
    },
  ];

  const handleApplyClick = (position) => {
    setSelectedPosition(position);
    setShowForm(true);
    setTimeout(() => {
      document.getElementById('application-form').scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  return (
    <div className="min-h-screen">
      <section className="page-hero">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_rgba(77,0,0,0.5),_transparent_45%),linear-gradient(135deg,#1a1214,#4D0000)]" />
        <div className="container relative z-10 mx-auto px-4">
          <p className="section-kicker text-primary-200">Careers</p>
          <h1 className="font-display text-5xl font-semibold md:text-6xl">Join Our Team</h1>
          <p className="mt-5 max-w-2xl text-xl text-white/85">
            Build your career with Sheryl Williams Hair Replacement. We are looking for focused professionals who support custom hair replacement clients.
          </p>
        </div>
      </section>

      <section className="bg-surface py-16">
        <div className="container mx-auto px-4">
          <div className="mb-12 text-center">
            <p className="section-kicker">Why work with us</p>
            <h2 className="section-heading mb-0">Grow inside a specialty practice</h2>
          </div>
          <div className="grid gap-10 md:grid-cols-3">
            {[
              {
                title: 'Career Growth',
                copy: 'Ongoing training and advancement opportunities in hair replacement services.',
              },
              {
                title: 'Competitive Pay',
                copy: 'Strong compensation with performance-based incentives.',
              },
              {
                title: 'Supportive Team',
                copy: 'Collaborate with specialists who take craft and client care seriously.',
              },
            ].map((item) => (
              <div key={item.title} className="border-t border-primary-200 pt-6">
                <h3 className="font-display text-2xl font-semibold text-ink">{item.title}</h3>
                <p className="mt-3 text-ink-muted">{item.copy}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-white py-16">
        <div className="container mx-auto px-4">
          <div className="mb-12 text-center">
            <p className="section-kicker">Open roles</p>
            <h2 className="section-heading mb-0">Open Positions</h2>
          </div>
          <div className="space-y-6">
            {positions.map((position) => (
              <div
                key={position.title}
                className="border border-primary-100 bg-white p-6 transition duration-300 hover:shadow-md"
              >
                <div className="flex flex-col md:flex-row md:items-start md:justify-between md:gap-8">
                  <div>
                    <h3 className="font-display text-2xl font-semibold">{position.title}</h3>
                    <p className="mt-2 text-ink-muted">{position.description}</p>
                    <div className="mt-4">
                      <h4 className="font-semibold text-ink">Requirements</h4>
                      <ul className="mt-2 list-disc space-y-1 pl-5 text-ink-muted">
                        {position.requirements.map((req) => (
                          <li key={req}>{req}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  <div className="mt-4 shrink-0 md:mt-0">
                    <button
                      type="button"
                      onClick={() => handleApplyClick(position.title)}
                      className="rounded-full bg-primary-600 px-6 py-3 font-semibold text-white transition duration-300 hover:bg-primary-700"
                    >
                      Apply Now
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="application-form" className="bg-surface py-16">
        <div className="container mx-auto px-4">
          <h2 className="mb-12 text-center font-display text-4xl font-semibold">
            {showForm ? `Apply for ${selectedPosition}` : 'Apply for a Position'}
          </h2>
          <CareerForm initialPosition={selectedPosition} />
        </div>
      </section>
    </div>
  );
}

export default Careers;
